import React from 'react';
import { useParams } from 'react-router-dom';
import NotesTab from './NotesTab';
import { NotesTabProvider } from './context';

const NotesTabWithProvider = () => {
  const { contactId } = useParams();

  return (
    <NotesTabProvider contactId={contactId}>
      <NotesTab />
    </NotesTabProvider>
  );
};

export default NotesTabWithProvider;
